import React from 'react';
import { useTranslation } from 'react-i18next';

const MAP_SRC = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2781.322478392167!2d9.082742015661891!3d45.80479967910638!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47869d98d5cb7249%3A0x41763a2a5f392955!2sMaithai%20-%20Massaggi%20Thailandese!5e0!3m2!1sen!2sit!4v1664761783802!5m2!1sen!2sit';

const FindUs = () => {
  const { t } = useTranslation();
  const boxRef = React.useRef(null);
  const [showMap, setShowMap] = React.useState(false);

  /* Precarica la mappa quando l'utente è ancora ~1200px sopra la sezione,
     così all'arrivo è già pronta (loading="lazy" la caricava troppo tardi) */
  React.useEffect(() => {
    const el = boxRef.current;
    if (!el || !('IntersectionObserver' in window)) {
      setShowMap(true);
      return undefined;
    }
    const io = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setShowMap(true);
          io.disconnect();
        }
      },
      { rootMargin: '1200px 0px' },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div className="section--light section__padding" id="contact">
      <div className="app__container">
        <div className="section__title">
          <h1 className="headtext__cormorant">{t('find')}</h1>
          <div className="section__title-accent" />
        </div>

        <div className="app__wrapper">
          <div className="app__wrapper_info">
            <p className="p__opensans1"><big>{t('via')}</big></p>
            <p className="p__opensans1"><i><small>{t('please')}</small></i></p>
            <p className="p__opensans1"><i><small>{t('our_2')}</small></i></p>
          </div>
          <div className="app__wrapper_img" ref={boxRef}>
            {showMap ? (
              <iframe
                title="Mappa MaiThai"
                src={MAP_SRC}
                height="420"
                style={{ border: 0 }}
                allowFullScreen=""
                referrerPolicy="no-referrer-when-downgrade"
              />
            ) : (
              <div style={{ height: 420, width: '100%', borderRadius: 'var(--radius-card)', background: '#EFE6D6' }} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FindUs;
